module.exports = require("core-js/library/fn/array/is-array");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/core-js/array/is-array.js
// module id = 1449
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16